import * as React from "react";
import ErrorLabel from "ui/atoms/ErrorLabel";

import cn from "../utils/tailwind/cn";

/**
 * @deprecated Replace with text field of type "file"
 */
export const FileInput = React.forwardRef(
  (
    { disabled, onChange, name, hasError, accept, errorLabel, ...props },
    ref,
  ) => (
    <>
      <input
        accept={accept}
        className={cn(
          "form-input focus:!border-primary focus:shadow-[0_0_0_2px_rgba(5,130,255,0.08)] border block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
          {
            "border-red-500": hasError,
          },
        )}
        disabled={disabled}
        name={name}
        onChange={onChange}
        ref={ref}
        type="file"
        {...props}
      />
      {hasError && <ErrorLabel>{errorLabel}</ErrorLabel>}
    </>
  ),
);

export default FileInput;
